import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import "../sass/layout/divLinks/divLinks.css";
import searchIcon from "../utils/img/search.png";
import exportar from "../utils/img/share.png";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getButtonsInHome } from "../services/actions/home.action";
import { Mixpanel } from "../utils/mixpanelIntegration";
import UserService from "../services/api/UserService";

const DivLinks = ({ retireeId = '' }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useSelector((state) => state.homeReducer.location?.data);
  const buttons = useSelector((state) => state.homeReducer.buttons);

  useEffect(() => {
    if (location?.uniqueNonGuessableId || retireeId) {
      const id = location?.uniqueNonGuessableId || retireeId
      getButtonsInHome(dispatch, id , !!retireeId );
    }
  }, [dispatch, location, retireeId]);

  return (
    <div style={{marginTop: '15px'}}>
      <Container fluid className="titles-box-classes">
        <h3 className="title-events-home">{t("homepage.quickLinks")}</h3>
      </Container>
      <Container
        fluid
        className={
          buttons.length > 1
            ? "divLink-container"
            : "divLink-container moreThanOne"
        }
      >
      {buttons.map((button, index) => {
        const isInternal = button.type === "internal_link";
        const handleClick = () =>
          Mixpanel.track("Button.Clicked", {
            buttonName: button.name,
            locationName: location?.name,
          });

        return isInternal ? (
          <Link
            key={index}
            to={button.link}
            className="first-box"
            onClick={handleClick}
          >
            <div className="divLink-text-container">
              <div className="a-href-color-white">
                <label>{button.name}</label>
              </div>
            </div>
            <img src={exportar} className="divLink-image"></img>
          </Link>
        ) : (
          <a
            key={index}
            href={button.link}
            className="first-box"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClick}
          >
            <div className="divLink-text-container">
              <div className="a-href-color-white">
                <label>{button.name}</label>
              </div>
            </div>
            <img src={exportar} className="divLink-image"></img>
          </a>
        );
      })}
      <a
        href="https://member.bluecrossma.com/login?locale=en"
        className="first-box"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="divLink-text-container">
          <div>
            <label>{t("divlinks.myblue")}</label>
          </div>
        </div>
        <img src={exportar} className="divLink-image"></img>
      </a>
      <a
        href="https://www.mychart.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="first-box"
      >
        <div className="divLink-text-container">
          <label>{t("divlinks.healthPortal")}</label>
        </div>
        <img src={searchIcon} className="divLink-image"></img>
      </a>
      <a className="first-box">
        <div className="divLink-text-container">
          <label>{t("divlinks.phone")}</label>
        </div>
      </a>
    </Container>
    </div>
  );
};

export default DivLinks;
